/**
 * [navigationGuard - execute a full set of cascading navigation guards]
 * @param  {Aguments} guards [all args are expected to be async functions]
 */
export function navigationGuard (...guards) {
  return async (to, from, next) => {
    let nextWasCalled = false

    const wrappedNext = (...args) => {
      nextWasCalled = true
      return next(...args)
    }

    for (const guard of guards) {
      try {
        await guard(to, from, wrappedNext)
      } catch (e) {
        console.warn('An error occurred in a navigationGuard')
        console.warn(e)
      }
    }

    if (!nextWasCalled) {
      return next()
    }
  }
}
